import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
} from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

export const ContentLibraryLoadingModal: FC<{
  open: boolean;
  onClose: () => void;
}> = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="lg">
      <DialogTitle my={2}>{t("Content Library")}</DialogTitle>
      <DialogContent>
        <LinearProgress />
      </DialogContent>
      <DialogActions>
        <Button data-analytics-id="content-library-loading-cancel" type="button" onClick={onClose}>
          {t("Cancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
